(function () {
  // Top-level mobile menu <details>
  var drawer = document.getElementById('Details-menu-drawer-container');
  if (!drawer) return;

  // StickyHeader checks this wrapper for 'menu-open'
  var headerSection = drawer.closest('.section--header') ||
                      document.querySelector('.section--header');

  function lockScrollNav() {
    // avoid stomping another feature’s lock
    if (document.body.dataset.lockOwner && document.body.dataset.lockOwner !== 'nav') return;

    var y = window.scrollY || window.pageYOffset || 0;
    document.body.dataset.lockOwner = 'nav';
    document.body.dataset.scrollY = String(y);

    // robust, iOS-safe fixed-body lock
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + y + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    // rein-in background scroll on some browsers
    document.documentElement.style.overflow = 'hidden';

    // let StickyHeader know menu is open
    if (headerSection) headerSection.classList.add('menu-open');
  }

  function unlockScrollNav() {
    // only undo our own lock
    if (document.body.dataset.lockOwner === 'nav') {
      var y = parseInt(document.body.dataset.scrollY || '0', 10) || 0;

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.documentElement.style.overflow = '';

      delete document.body.dataset.lockOwner;
      delete document.body.dataset.scrollY;

      window.scrollTo(0, y);
    }

    // clean up common lock classes from any 3rd-party
    document.body.classList.remove('lock','js-lock','overflow-hidden','no-scroll');
    document.documentElement.classList.remove('lock','js-lock','overflow-hidden','no-scroll');

    // if any stylesheet still computes hidden, force visible
    document.body.style.setProperty('overflow', 'visible', 'important');
    document.body.style.setProperty('overflow-y', 'auto', 'important');

    // clear sticky marker if someone left it behind
    if (headerSection) headerSection.classList.remove('menu-open');
  }

  // Keep lock in sync with the <details> state
  drawer.addEventListener('toggle', function () {
    if (drawer.open) lockScrollNav(); else unlockScrollNav();
  });

  // Close buttons: explicitly close the <details> and unlock
  document.querySelectorAll('[data-menu-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      drawer.removeAttribute('open');
      unlockScrollNav();
    });
  });

  // Defensive: if a script flips body overflow after close, flip it back once
  var once = new MutationObserver(function () {
    if (!drawer.open && getComputedStyle(document.body).overflow === 'hidden') {
      document.body.style.setProperty('overflow', 'visible', 'important');
      document.body.style.setProperty('overflow-y', 'auto', 'important');
      once.disconnect();
    }
  });
  once.observe(document.body, { attributes:true, attributeFilter:['style','class'] });

  // First paint normalization (e.g., Theme Editor left state dirty)
  if (!drawer.open) unlockScrollNav();
})();
